export default __webpack_public_path__ + "static/media/Futura-Bold.6b51fb9b.woff2";